<div class="question-wrapper-mcms Vertical-view-checkbox" *ngIf="displayMode == 'Vertical'">
  <div class="div-content sentence-align">
    <ng-component class="editor-question" [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
  </div>

  <div class="answer-container div-options" *ngFor="let o of questions?.options | orderBy: 'arrangeOrder'">
    <mat-checkbox class="" [disabled]='isReadOnly' [ngModel]="o?.answerValid" class="options">
        <ng-component class="editor-radio" [innerHTML]="sanitizer.bypassSecurityTrustHtml(o?.answerDescription?.description)"></ng-component>
    </mat-checkbox>
  </div>
</div>


<div class="question-wrapper-mcms horizontal-view-checkbox" *ngIf="displayMode == 'Horizontal'">
  <div class="col-w-40">
    <div class="div-content sentence-align">
      <ng-component class="editor-question" [innerHTML]="sanitizer.bypassSecurityTrustHtml(questions?.questiondescription?.description)"></ng-component>
    </div>
  </div>
  <div class="col-w-60">
    <div class="answer-container div-options" *ngFor="let o of questions?.options | orderBy: 'arrangeOrder'">
      <mat-checkbox class="" [disabled]='isReadOnly' [ngModel]="o?.answerValid" class="options">
          <ng-component class="editor-radio" [innerHTML]="sanitizer.bypassSecurityTrustHtml(o?.answerDescription?.description)"></ng-component>
      </mat-checkbox>
    </div>
  </div>
</div>
